(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.body.classList.add('motion-ready');

  const assignAnimations = () => {
    const sections = document.querySelectorAll('.shopify-section');
    sections.forEach((section) => {
      const hero = section.querySelector('.hero, .home-hero, .coming-soon-hero, .limited-hero');
      if (hero) {
        const heroHeading = hero.querySelector('h1, h2');
        const heroText = hero.querySelector('p');
        const heroActions = hero.querySelectorAll('.button, .button-wide');
        if (heroHeading && !heroHeading.dataset.animate) heroHeading.dataset.animate = 'fade-up';
        if (heroText && !heroText.dataset.animate) heroText.dataset.animate = 'fade-up';
        heroActions.forEach((el) => {
          if (!el.dataset.animate) el.dataset.animate = 'zoom-in';
        });
      }

      const titles = section.querySelectorAll('.product-grid-top-text, .what-are-text, .archive-collection-header__left, .title, .contact-main__form-inner > h3');
      titles.forEach((el) => {
        if (!el.dataset.animate) el.dataset.animate = 'fade-up';
      });

      const cards = section.querySelectorAll(
        '.product-grid-item, .grid-item, .archive-collection-grid-item, .steps-item, .stat-item, .contact-top-bar__item, .coming-soon-grid .grid-item'
      );
      cards.forEach((card) => {
        if (!card.dataset.animate) card.dataset.animate = 'fade-up';
        if (!card.dataset.float && card.matches('.product-grid-item, .grid-item, .archive-collection-grid-item, .steps-item')) {
          card.dataset.float = 'true';
        }
      });
    });
  };

  const setupRevealObserver = () => {
    const targets = document.querySelectorAll('[data-animate]');
    if (prefersReducedMotion) {
      targets.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach((el) => observer.observe(el));
  };

  const revealInViewImmediately = () => {
    const viewportBottom = window.innerHeight * 0.96;
    const targets = document.querySelectorAll('[data-animate]');
    targets.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < viewportBottom && rect.bottom > 0) {
        el.classList.add('is-visible');
      }
    });
  };

  const setupCardFloat = () => {
    if (prefersReducedMotion) return;
    const floatCards = document.querySelectorAll('[data-float]');
    floatCards.forEach((card) => {
      card.addEventListener('mousemove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 8;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * -8;
        card.style.transform = `perspective(1000px) rotateX(${y}deg) rotateY(${x}deg) translateY(-3px)`;
      });

      card.addEventListener('mouseleave', () => {
        card.style.transform = '';
      });
    });
  };

  const init = () => {
    assignAnimations();
    revealInViewImmediately();
    setupRevealObserver();
    setupCardFloat();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.documentElement.classList.remove('motion-pending');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
